import {
	GET_BRANDS_SUCCESS,
	GET_SINGLE_BRAND_SUCCESS,
	RESTORE_SINGLE_BRAND_SUCCESS,
	SOFT_DELETE_SINGLE_BRAND_SUCCESS,
} from "../actions/products/brands/brands.actionType";
import globalState from "../state";

const requestRegex = /_REQUEST/;
const errorRegex = /_FAILURE/;
const successRegex = /_SUCCESS/;

const initialState = {
	errorMessage: "",
	isLoading: false,
	brands: [],
	brand: {},
	...globalState,
};

const BrandReducer = (state = initialState, action) => {
	const isRequest = requestRegex.test(action.type);
	const isError = errorRegex.test(action.type);
	const isSuccess = successRegex.test(action.type);

	if (isRequest) {
		return { ...state, isLoading: true, errorMessage: "" };
	}
	if (isError) {
		return { ...state, isLoading: false, errorMessage: action.message };
	}
	if (isSuccess) {
		state = { ...state, isLoading: false, errorMessage: "" };
	}

	switch (action.type) {
		case GET_BRANDS_SUCCESS:
			return { ...state, brands: action.data };

		case GET_SINGLE_BRAND_SUCCESS:
			return { ...state, brand: action.data };

		case SOFT_DELETE_SINGLE_BRAND_SUCCESS:
			let softDeletedBrandId = action.data;
			let afterSoftDeletedData = state.brands.filter(
				(data) => data.id.toString() !== softDeletedBrandId.toString()
			);
			return { ...state, brands: afterSoftDeletedData };

		case RESTORE_SINGLE_BRAND_SUCCESS:
			return { ...state };

		default:
			return state;
	}
};

export default BrandReducer;
